<template>
  <div>
    <div v-if="enoughDetailsToShow" class="flex -mx-5">
      <div class="flex-shrink px-5">
        <h4>Submitted Info</h4>
        <div v-if="computedOrganization.filemakerOrganizationId" class="mb-3">
          <p class="font-bold">
            Organization ID
          </p>
          <p v-text="computedOrganization.filemakerOrganizationId" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Organization Name
          </p>
          <p v-text="computedOrganization.name" />
        </div>
        <div v-if="computedOrganization.businessType" class="mb-3">
          <p class="font-bold">
            Business Type
          </p>
          <p v-text="computedOrganization.businessType" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Email
          </p>
          <p v-text="computedOrganization.email" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Address
          </p>
          <p>
            {{ computedOrganization.addressLine1 }}<br>
            <span v-if="computedOrganization.addressLine2">{{ computedOrganization.addressLine2 }}</span><br v-if="computedOrganization.addressLine2">
            {{ computedOrganization.city }}, {{ computedOrganization.state }}, {{ computedOrganization.country }}
          </p>
        </div>
        <div v-if="computedOrganization.websiteUrl" class="mb-3">
          <p class="font-bold">
            Website URL
          </p>
          <p v-text="computedOrganization.websiteUrl" />
        </div>
        <div v-if="computedOrganization.phone" class="mb-3">
          <p class="font-bold">
            Phone #
          </p>
          <p v-text="computedOrganization.phone" />
        </div>
        <div v-if="computedOrganization.fax" class="mb-3">
          <p class="font-bold">
            Fax #
          </p>
          <p v-text="computedOrganization.fax" />
        </div>
      </div>
      <div class="px-10 relative flex-grow">
        <div class="vertical-divider" />
      </div>
      <div class="w-5/12 px-5">
        <h4 class="px-8">
          Similar Organizations
        </h4>
        <div v-if="loadingSimilars" class="text-center py-10">
          <d-loader />
          <p>Fetching similiar organizations...</p>
        </div>
        <div v-else class="px-8">
          <div v-for="similar in similars" :key="similar.name" class="bg-white rounded border border-gray-500 p-5 cursor-pointer mb-4" @click="showCompareModal(similar)">
            <p class="font-bold text-lg">
              {{ similar.name }}
            </p>
            <p>
              Organization ID: {{ similar.filemakerOrganizationId }}
            </p>
            <p v-if="similar.membershipType">
              Membership Type: {{ similar.membershipType }}
            </p>
            <p v-if="similar.status">
              Status: {{ similar.status }}
            </p>
            <p>
              Address: {{ similar.city }}, {{ similar.state }}<span v-if="similar.country">, {{ similar.country }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="mb-10">
      User responded that no organization information was available
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { mapFilemakerFirmToFirmSubmission } from '@resources/scripts/services/projectRegistration.service';
  import CompareOrganizationModal from './CompareOrganizationModal.vue';

  export default {
    props: {
      organization: {
        type: Object,
        default: () => ({}),
      },

      submissionSource: String,
    },

    data() {
      return {
        similars: [],
        loadingSimilars: true,
      };
    },

    computed: {
      computedOrganization: {
        get() {
          return this.organization;
        },
        set(value) {
          this.$emit('update:organization', value);
        },
      },

      enoughDetailsToShow() {
        return this.computedOrganization.name || this.computedOrganization.email || this.computedOrganization.fax;
      },
    },

    mounted() {
      if (this.enoughDetailsToShow) {
        this.queryFileMakerFirms();
      }
    },

    methods: {
      async queryFileMakerFirms() {
        if (this.computedOrganization.filemakerOrganizationId) {
          const { data } = await axios.post('/api/organizations/query/paged?currentPage=1&pageSize=5', {
            'Organization ID': this.computedOrganization.filemakerOrganizationId,
          });
          this.similars = data.resultItems.map(firm => mapFilemakerFirmToFirmSubmission(firm, this.submissionSource));
          this.loadingSimilars = false;
        } else {
          const { data } = await axios.post('/api/organizations/query/paged?currentPage=1&pageSize=5', {
            'Organization Name': this.computedOrganization.name,
            'Address City': this.computedOrganization.city,
            'Address State': this.computedOrganization.state,
          });
          this.similars = data.resultItems.map(firm => mapFilemakerFirmToFirmSubmission(firm, this.submissionSource));
          this.loadingSimilars = false;
        }
      },

      showCompareModal(selectedSimilar) {
        this.$modal.open({
          parent: this,
          width: 900,
          component: CompareOrganizationModal,
          hasModalCard: true,
          props: {
            submittedInfo: this.computedOrganization,
            existingInfo: selectedSimilar,
          },
          events: {
            setRevisedInfo: (data) => {
              this.computedOrganization = data;
              this.$emit('save-changes', true);
            },
          },
        });
      },
    },
  };
</script>